import FacebookLogin from '@common/components/FacebookLogin';
import GoogleLogin from '@common/components/GoogleLogin';
import { smoothScroll } from '@common/utils';
import { handleLoginResponse } from '@common/utils/auth';
import PageLayout from '@components/PageLayout';
import Link from '@lib/Link';
import classnames from 'classnames';
import React, { useEffect } from 'react';
import { Redirect } from 'react-router-dom';

import { computeRedirectUrl } from '../../../../common/utils/computation';
import { getBuyerJWTToken } from '../../../../common/utils/token';
import LoginForm from './LoginForm';
export interface LoginProps {
  isModal?: boolean;
  switchToRegister?: () => void;
  switchToForgotPassword?: () => void;
  afterLogin?: () => void;
}
const Login: React.FC<LoginProps> = ({ isModal, switchToRegister, afterLogin, switchToForgotPassword }) => {
  useEffect(() => {
    smoothScroll(0, 0);
  }, []);
  const getSwitchToRegisterContent = () => {
    return (
      <div
        className="text-right text-14 text-theme underline"
        font-customisation="para-text"
        color-customisation="page-body-text"
      >
        Don&apos;t have an account? Register here
      </div>
    );
  };
  const getSwitchToForgotPasswordContent = () => {
    return (
      <div
        className="mt-24 text-right text-14 text-theme underline"
        font-customisation="para-text"
        color-customisation="page-body-text"
      >
        Forgot Password?
      </div>
    );
  };
  if (!isModal && getBuyerJWTToken()) {
    return <Redirect to="/" />;
  }
  const redirectUrl = computeRedirectUrl();

  const getLoginContent = () => {
    return (
      <div className="container mx-auto">
        <div
          className={classnames('bg-white rounded md:shadow px-16 md:pl-64 md:pr-48', {
            'pt-24 pb-40 md:mt-32 md:mb-70': !isModal,
            '-mt-26 pb-40': isModal,
          })}
        >
          {isModal ? (
            <div
              className="#444463 text-18 text-auth-header"
              font-customisation="section-heading"
              color-customisation="page-heading"
            >
              Login
            </div>
          ) : (
            <div
              className="font-medium text-24 md:mb-24"
              font-customisation="section-heading"
              color-customisation="page-heading"
            >
              Login to our Store
            </div>
          )}
          <div className="flex flex-wrap justify-center">
            <div className="w-full md:flex-1">
              <LoginForm isModal={isModal} onSubmitHandler={handleLoginResponse} afterLogin={afterLogin} />
              <div className="flex justify-between">
                {isModal && (
                  <div className="cursor-pointer" onClick={switchToRegister}>
                    <div
                      className="mt-24 text-right text-14 text-theme underline"
                      font-customisation="para-text"
                      color-customisation="page-body-text"
                    >
                      Register account
                    </div>
                  </div>
                )}
                {isModal ? (
                  <div className="cursor-pointer" onClick={switchToForgotPassword}>
                    {getSwitchToForgotPasswordContent()}
                  </div>
                ) : (
                  <Link to={`/account/forgot-password?redirect_url=${redirectUrl}`}>
                    {getSwitchToForgotPasswordContent()}
                  </Link>
                )}
              </div>
            </div>
            <div
              className={classnames(' md:mr-20 md:ml-40 md:mb-0 text-center', {
                'my-24 md:mt-120': !isModal,
                'mt-8 text-13 text-label md:mt-80': isModal,
              })}
              font-customisation="para-text"
              color-customisation="page-body-text"
            >
              OR
            </div>
            <div className="w-full md:flex-1">
              {!isModal ? (
                <div
                  className="font-medium text-16 mb-24 mt-0 md:mt-36 text-center md:text-left"
                  font-customisation="section-heading"
                  color-customisation="page-heading"
                >
                  Use social media account
                </div>
              ) : (
                <div className="mb-32"></div>
              )}
              <div className={classnames({ 'mb-16': !isModal, 'mb-20': isModal })} font-customisation="para-text">
                <GoogleLogin isModal={isModal} />
              </div>
              <div className="mb-24" font-customisation="para-text">
                <FacebookLogin isModal={isModal} />
              </div>
              {!isModal && (
                <Link to={`/account/register?redirect_url=${redirectUrl}`}>{getSwitchToRegisterContent()}</Link>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  };
  return (
    <div className={classnames('bg-page', { 'pt-64': !isModal, 'pt-0': isModal })} color-customisation="page-bg">
      {isModal && getLoginContent()}
      {!isModal && <PageLayout>{getLoginContent()}</PageLayout>}
    </div>
  );
};

export default Login;
